import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Redirect } from 'react-router-dom'
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import WidePrimaryButton from 'components/WidePrimaryButton';
import AppView from 'areas/shell/components/AppView';
import LocationDialog from 'areas/location/components/LocationDialog';
import { H1, H5, Body2 } from 'components/Typography';
import QRCodeReaderDialog from 'components/QRCodeReaderDialog';
import QRCodeScannerDialog from 'components/QRCodeScannerDialog';
import AuthenticationCodeDialog from 'areas/auth/components/AuthenticationCodeDialog';
import alertActions from 'areas/alert/actions';
import * as authActions from 'areas/auth/actions';
import { loadDivisionData } from 'areas/location/actions';
import classNames from 'classnames';
import isStringSet from 'utilities/is/isStringSet';
import styles from './styles';
import MediaQuery from 'react-responsive';
import FooterLink from 'components/FooterLink';
import FooterDivider from 'components/FooterDivider';
import QRGun from 'components/Icons/QRGun';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import { browser } from 'components/BrowserSupport/';
import m from 'messages';
import { DateTime } from 'luxon';
// import { reactPlugin } from "../../appInsights";
// import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

const LoginPage = class extends React.Component {

    handleSendAuthCode = (sendSms, sendEmail) => {
        this.props.handleSendAuthCode(this.props.qrCode, sendSms, sendEmail);
    };

    updateDetails = () => {
        window.open(`${this.props.config.baseURL}/MySkillGuard`, "_blank");
    };

    confirmClicked = (authCode) => {
        this.props.continueAuthentication(this.props.qrCode, authCode);
    };

    handleVisitorPassScan = (qrCode, callback) => {
        this.props.showWarning(m.pages.login.cannotLogInWithVisitorPass, callback);
    };

    qrDialog = (qrCodeDialogOpen) => {
        return (
            <QRCodeReaderDialog
                title={m.scan.scanQrCodeTitle}
                open={!!qrCodeDialogOpen}
                onScanError={this.props.showWarning}
                handleClose={this.props.handleQrDialogClose}
                onVisitorPassScanned={this.handleVisitorPassScan}
                onCardScanned={this.props.authInitialise} />);
    };

    qrScannerDialog = (qrScannerDialogOpen) => {
        return (
            <QRCodeScannerDialog
                title={m.scan.scanQrCodeTitle}
                open={!!qrScannerDialogOpen}
                handleClose={this.props.handleQrDialogClose}
                onCardScanned={this.props.authInitialise}
                onScanError={this.props.showWarning}
                onVisitorPassScanned={this.handleVisitorPassScan} />
        );
    };

    authDialog = (authCodeDialogOpen) => {
        return (
            <AuthenticationCodeDialog
                open={authCodeDialogOpen}
                handleClose={this.props.handleAuthDialogClose}
                updateDetails={this.updateDetails}
                sendAuthCode={this.handleSendAuthCode}
                confirmClicked={this.confirmClicked}>
            </AuthenticationCodeDialog>
        );
    };

    locationDialog = (isLocationDialogOpen) => {
        return (
            <LocationDialog
                canCancel={false}
                handleClose={() => { }}
                onLoadDivisions={() => this.props.loadDivisions()}
                open={!!isLocationDialogOpen} />
        );
    };

    loginButtons = (classes) => {
        const productName = `${this.props.sgAppName} ${this.props.longTitle}`;
        return (
            <div>
                <H5 paragraph style={{ fontWeight: 600, textAlign: 'center', marginTop: 15 }}>
                    {m.pages.login.loginInWelcomeMessage(productName)}
                </H5>
                <Body2 paragraph style={{ fontWeight: 500, textAlign: 'center', marginTop: 5 }} dangerouslySetInnerHTML={{ __html: m.pages.login.loginMessage }}>
                </Body2>
                <div style={{ marginTop: 20 }}>
                    <WidePrimaryButton
                        className={classes.scanButton}
                        onClick={this.props.openQrCodeDialog}>
                        <span style={{ float: 'left' }}>
                            <CameraIcon />
                        </span>
                        {m.pages.login.useCamera}
                    </WidePrimaryButton>

                    {!browser.mobile &&
                        <WidePrimaryButton
                            className={classNames(classes.scanButton, classes.gunIcon)}
                            onClick={this.props.openQrScannerDialog}>
                            <span style={{ float: 'left' }}>
                                <QRGun />
                            </span>
                            {m.pages.login.useScanner}
                        </WidePrimaryButton>
                    }
                </div>
            </div>
        );
    };

    loginHeader(isMobile) {
        return (
            <AppBar position="fixed" className={this.props.classes.loginBar} elevation={0}>
                <Toolbar>
                    <H1 className={classNames(this.props.classes.loginBarText, this.props.classes.grow)}>
                        {isMobile
                            ? <span>{this.props.shortTitle}</span>
                            : this.breakWord(this.props.longTitle)
                        }
                    </H1>
                    <img src="/logo.png" alt="logo" className={this.props.classes.logo} />
                </Toolbar>
            </AppBar>
        );
    }

    breakWord(title) {
        if (!title) return (<span></span>);

        const words = title.split(' ');
        if (words.length > 1) {
            return (
                <span>
                    <span className={this.props.classes.firstWord}>{words[0]}</span>
                    <span> {words.slice(1).join(' ')}</span>
                </span>
            );
        } else {
            return (<span>{title}</span>);
        }
    }

    footer() {
        const {
            classes,
            sgAppBaseUrl,
            sgAppName,
            myAppName,
            myAppUrl
        } = this.props;

        return (
            <footer className={classes.footer}>
                <ul className={classes.footerUl}>
                    <FooterLink text="&copy;" />
                    <FooterLink text={DateTime.utc().year.toString()} />
                    <FooterLink href="https://causeway.com" text="Causeway Technologies Ltd" />
                    <FooterDivider />
                    <FooterLink href={sgAppBaseUrl} text={sgAppName} hideOnMobile={true} />
                    <FooterDivider />
                    <FooterLink href={myAppUrl} text={myAppName} hideOnMobile={true} />
                    <FooterDivider />
                    <FooterLink href="https://support.riw.net.au/support/solutions" text="RIW Knowledge Centre" target="_blank" hideOnMobile={false} />
                </ul>
            </footer>
        );
    }
    render() {
        const {
            classes,
            config,
            isQrDialogOpen,
            isQrScannerDialogOpen,
            isAuthCodeDialogOpen,
            isLocationDialogOpen,
            shouldRedirect } = this.props;

        if (shouldRedirect) {
            return (<Redirect to='/' />);
        }

        const backgroundImageUrl = 'url(/hero.png)';
        return (
            // <AppInsightsErrorBoundary onError={() => <h1>I believe something went wrong</h1>} appInsights={reactPlugin}>
                <MediaQuery maxWidth={767}>
                    {(isMobile) =>
                        <AppView
                            title={m.pages.login.title(config.appName)}
                            appBar={this.loginHeader(isMobile)}
                            hideNavigation={true}
                            contentClass={classes.loginContent}>
                            {this.qrDialog(isQrDialogOpen)}
                            {this.qrScannerDialog(isQrScannerDialogOpen)}
                            {this.authDialog(isAuthCodeDialogOpen)}
                            {this.locationDialog(isLocationDialogOpen)}
                            <main className={classes.main}>
                                <div id="hero" className={classes.hero} style={{ backgroundImage: backgroundImageUrl }}></div>
                                <Grid container style={{ flex: 1 }} className={classes.loginContainer}>
                                    <Grid item xs={12}>
                                        <Grid container alignItems="center" justifyContent="center" direction="row">
                                            <div className={classes.panel}>
                                                {this.loginButtons(classes)}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {this.footer()}
                            </main>
                        </AppView>
                    }
                </MediaQuery>
            // </AppInsightsErrorBoundary>
        );
    }
}

function mapStateToProps(state) {
    const {
        auth,
        config,
        location
    } = state;

    const isQrDialogOpen = auth.qrCodeDialogOpen;
    const isQrScannerDialogOpen = auth.qrScannedDialogOpen;
    const isAuthCodeDialogOpen = auth.authCodeDialogOpen && isStringSet(auth.qrCode);
    const isLocationDialogOpen = auth.loggedIn && !location.valid
    const shouldRedirect = auth.loggedIn && location.valid;

    return {
        config,
        longTitle: config.appName,
        shortTitle: config.shortAppName,
        qrCode: auth.qrCode,
        loggedIn: auth.loggedIn,
        shouldRedirect,
        logo: config.iconLarge || '',
        isQrDialogOpen,
        isQrScannerDialogOpen,
        isAuthCodeDialogOpen,
        isLocationDialogOpen,
        sgAppBaseUrl: config.homePageUrl,
        sgAppName: config.productName,
        myAppUrl: `${config.baseURL}/MySkillGuard`,
        myAppName: config.myProductName
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadDivisions: () => dispatch(loadDivisionData()),
        showWarning: (message, callback) => dispatch(alertActions.warn(message, callback)),
        authInitialise: (qrCode, callback) => dispatch(authActions.initialise(qrCode, callback)),
        continueAuthentication: (qrCode, authCode) => dispatch(authActions.continueAuthentication(qrCode, authCode)),
        handleSendAuthCode: (qrCode, sendSms, sendEmail) => dispatch(authActions.sendCode(qrCode, sendEmail, sendSms)),
        openQrCodeDialog: () => dispatch(authActions.openQrDialog()),
        openQrScannerDialog: () => dispatch(authActions.openQrScannerDialog()),
        handleQrDialogClose: () => dispatch(authActions.closeQrDialog()),
        openAuthCodeDialog: () => dispatch(authActions.openAuthCodeDialog()),
        handleAuthDialogClose: () => dispatch(authActions.closeAuthCodeDialog()),
    };
}

const styledLoginPage = withStyles(styles)(LoginPage);
const routedLoginPage = withRouter(styledLoginPage);
const connectedLoginPage = connect(mapStateToProps, mapDispatchToProps)(routedLoginPage);

export default connectedLoginPage;